import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { getImageUrl } from "@/lib/imageUrl";


const clients = [
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(1).webp"), alt: "Client Logo 1",link:'https://www.thaithingal.in/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(2).webp"), alt: "Client Logo 2",link:'https://www.tamiltshirts.in/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(3).webp"), alt: "Client Logo 3",link:'' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(4).webp"), alt: "Client Logo 4",link:'https://www.adyarhandicrafts.com/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(5).webp"), alt: "Client Logo 5",link:'https://www.magizhhandicrafts.com/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(6).webp"), alt: "Client Logo 6",link:'https://bogilife.com/' },
  // { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(7).webp"), alt: "Client Logo 7",link:'https://gimart.online/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(8).webp"), alt: "Client Logo 8",link:'https://www.meesakar.in/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(9).webp"), alt: "Client Logo 9",link:'' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(10).webp"), alt: "Client Logo 10",link:'' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(11).webp"), alt: "Client Logo 11",link:'https://gobrapaints.com/' },
  // { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(12).webp"), alt: "Client Logo 12",link:'https://zemdrop.in/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(13).webp"), alt: "Client Logo 13",link:'https://cleanflowsystem.com/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(14).webp"), alt: "Client Logo 14",link:'' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(15).webp"), alt: "Client Logo 15",link:'https://www.mypolo.in/' },
  { src: getImageUrl("/vilvabusiness/website/blogs/client/blog_client%20(16).webp"), alt: "Client Logo 16",link:'https://brassidols.com/' },
];

const OurClients = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 8;
  const totalPages = Math.ceil(clients.length / itemsPerPage);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex + itemsPerPage >= clients.length ? 0 : prevIndex + itemsPerPage
      );
    }, 3000); // Slide every 3 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const handlePageClick = (pageIndex) => {
    setCurrentIndex(pageIndex * itemsPerPage);
  };

  const visibleClients = clients.slice(currentIndex, currentIndex + itemsPerPage);

  return (
    <section className='mb-10'>
      <h2 className='mb-2 text-[#090D28] text-[18px] font-[600] leading-[100%] font-LatinkaBold'>Our Clients</h2>
      <div className="flex mb-6 flex-col items-start p-6 gap-6 self-stretch rounded-[8px] border-2 border-[#E2E8FB] bg-[#F6F8FE]">
        <div className='grid grid-cols-2 w-full gap-6'>
          {visibleClients.map((client, index) => (
            <a
              key={index}
              href={client.link}
              target="_blank"
              className='flex items-center justify-start'
              rel="noopener noreferrer"
            >
              <Image 
                src={client.src}
                className="w-[90px] h-[50px] mx-auto object-contain img-fluid"
                alt={client.alt}
                width={200}
                height={200}
              />
              
            </a>
          ))}
        </div>
        <div className="flex justify-center mx-auto w-full gap-2 mt-4">
          {Array.from({ length: totalPages }).map((_, index) => (
            <button
              key={index}
              onClick={() => handlePageClick(index)}
              className={`w-2 h-2 rounded-full ${
                currentIndex / itemsPerPage === index 
                  ? 'bg-black' 
                  : 'bg-gray-400 hover:bg-gray-500'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurClients;